import { CircularProgress, InputAdornment } from '@material-ui/core';
import React from 'react';

export default function() {
  return (
    <InputAdornment position="end">
      <CircularProgress size={20} />
    </InputAdornment>
  );
}
